module.exports = __webpack_public_path__ + "img/2.8094865d.jpg";